export enum LICENSE_TYPE {
  POT = "POT",
  POC = "POC",
  Pilot = "Pilot",
  Customer = "Customer",
  Training = "Training",
  Partner = "Partner",
  Internal= "Internal",
  POC_ONPREM = "POC_ONPREM",
  Trial = "Trial",
  SI = "SI",
  End_User = "End_User",
  ONPREM = "ONPREM",
  SAAS = "SAAS",
}

export enum PRODUCT {
  SmartDoc = "SmartDoc",
  Transform = "Transform",
  Base_Runtime = "Base_Runtime",
  Runtime_Pro = "Runtime_Pro",
  Relocate = "Relocate",
  Atlas = "Atlas"
}

export const CARRYOVER_ENABLED_PRODUCTS: string[] = [
  PRODUCT.SmartDoc,
  PRODUCT.Atlas,
  PRODUCT.Transform,
];

export const isCarryoverEnabledProduct = (
  product?: string | null
): boolean => {
  if (!product) {
    return false;
  }
  return CARRYOVER_ENABLED_PRODUCTS.includes(product);
};

export enum LINES_OF_CODE_CATEGORY {
  LOW = 0,
  HIGH = 10000,
}

export enum SUPPORT_LEVEL {
  PREMIUM = "PREMIUM",
  PREMIUM_PLUS = "PREMIUM_PLUS",
}

export enum LICENSE_STATUS {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  REVOKED = "REVOKED",
  DECLINED = "DECLINED",
  EXPIRED = "EXPIRED",
}

export enum ENVIRONMENT {
  SAAS = "SAAS",
  ONPREM = "ONPREM",
  ZOS = "ZOS",
  Training = "Training"
}
